<template>
	
	<v-dialog
	    v-model="visible"
		persistent
	    width="1000"
		class="dialog"
		ref="editDialog"
		eager
	>
		<v-card>
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text  class="mx-0 pa-0 my-1 d-flex dialog-content">
                <div class="flex-grow-1 flex-shrink-1" style="position:relative;">
                    <div style="position:absolute;top:0px;left:0px;right:0px;bottom:0px;">
                        <v-data-table :headers="couponActivityHeaders"  fixed-header :items="activitys" 
                            class="elevation-0 result-table"
                            width="100%"
                            height="100%"
                            show-select 
                            item-key="activityId"
                            :calculate-widths='false'
                            :hide-default-footer='true'
                            :disable-pagination='true'
                            v-model="selectedActivitys"
                            :single-select="!multiSelect"
                        >
                        </v-data-table>
                    </div>
                </div>
            </v-card-text>

            <v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  
			  <v-btn
				color="success"
				class="left-round"
				@click="handleSave"
			  >				
                <span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>
				选择
				
			  </v-btn>

              <v-btn
				color="blue-grey"
				class="right-round"
				@click="cancelClicked"
			  >
				
				取消
                <span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
			  </v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>

    import DragSupport from '../../../../../util/drag.js';
    import CouponActivityApi from "../../../../../api/sm/market/printcoupon/CouponActivityApi.js";
    import Permission from "../../../../../api/smp/auth/Permission.js";

    export default {
        name: 'Sm-Market-Printcoupon-ActivitySelectDialog',
            components: {
                
            },
            data: () => ({          
                visible:false,
                
                title:"选择打印送券活动",
                activitys:[],
                selectedActivitys:[],

                multiSelect:true,

                couponActivityHeaders:[
                    {text: '活动号',value: 'activityId',sortable: false,width: 80,divider: true},
                    {text: '活动名',value: 'activityName',sortable: false,width: 160,divider: true},
                    {text: '券编号',value: 'couponId',sortable: false,width: 80,divider: true},
                    {text: '券名称',value: 'couponName',sortable: false,width: 220,divider: true},
                    {text: '开始日期',value: 'startDate',sortable: false,width: 200,divider: true},
                    {text: '结束日期',value: 'endDate',sortable: false,width: 200,divider: true},
                    {text: '消费金额',value: 'sharpAmount',sortable: false,width: 100,divider: true},
                    {text: '送券金额',value: 'couponAmount',sortable: false,width: 100,divider: true},
                    {text: '单笔最多送券金额',value: 'maxAmount',sortable: false,width: 100,divider: true},
                    {text: '每天最多送券金额',value: 'dayMaxAmount',sortable: false,width: 100,divider: true},
                    {text: '周几',value: 'weekDay',width: 40,sortable: false,divider: false},
                ],
                
            }),
            methods:{
                async errMsg(title,text){
                    await this.$dialog.error({
                        text: text,
                        title: title
                    });
                },
                setVisible(v){
                    this.visible=v;
                    let dialogEl = this.$refs.editDialog.$refs.dialog;
                    
                    if(this.visible==true)
                        DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
                    else
                        DragSupport.unbind(dialogEl);    

                    
                },
                clear(){
                    this.activitys = [];
                    this.selectedActivitys = [];
                },
                cancelClicked(){
                    this.clear();
                    this.setVisible(false);
                },
                handleSave(){
                    if((!this.selectedActivitys)||(!this.selectedActivitys.length)||(this.selectedActivitys.length<1)){
                        this.errMsg("错误","请选择打印赠券活动");
                        return;
                    }

                    let me = this;
                    let params = {selectedActivitys:me.selectedActivitys};

                    me.setVisible(false);
                    me.$emit("couponActivitySelected",params);
                },
                async loadCouponActivitys(){
                    let me = this;
                    let queryCouponActivityResp = await CouponActivityApi.queryCouponActivity();
                    console.log("load coupon activity returned;");

                    console.log(queryCouponActivityResp);

                    let data = queryCouponActivityResp.data;
                    if((!data)||(!(data.code))||(data.code!=200)){
                        let msg=data.msg;
                        msg = ((!msg)||(msg==''))?'获取打印送券活动失败':msg;
                        throw new Error(msg);
                        return;
                    }
                    if((!data.data)||(!data.data.couponActivitys)){
                        throw new Error('获取打印送券活动失败(无会话数据)');
                        return;
                    }
                    this.activitys = data.data.couponActivitys;
                },

                setActivitys(activitys){
                    this.activitys = activitys;
                },
                setMultiSelect(multiSelect){
                    this.multiSelect = multiSelect;
                }
            },
            created(){
                
            }
    }

</script>

<style scoped>

    .dialog{
		border-radius: 4px;
        width:1000px;
	}
    .dialog-content{
        height:550px;
         max-height: 600px;
         overflow-y: scroll;
    }
    .result-table{
        width:100%;
        height:100%;
    }
	.readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}

</style>
